import { Link } from 'react-router-dom';
import { EmptyState } from '../ui';

export function NotFound() {
  return (
    <div className="auth-wrap">
      <EmptyState
        title="404 — Page not found"
        description="That page does not exist."
        action={<Link to="/">Back to dashboard</Link>}
      />
    </div>
  );
}
